import styled from 'styled-components';
export const Loader = styled.div`
  display: flex;
  min-height: 52rem;
`;
export const LeftLoader = styled.div`
  width: 30%;
`;
export const RightLoader = styled.div`
width:70%

  min-width: 30%;
  padding-left: 22px;
  margin-left: 22px;
  border-left: 1px #dddddd solid;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  input {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    height: 40px;
    margin-bottom: 12px;
    padding: 0 8px;
  }
  p {
    font-size: 16px;
    line-height: 29px;
    color: #4a4a4e;
    font-weight: 800;
  }
`;
export const ReportContainer = styled.div`
  .datePickerConatiner {
    position: relative;
    bottom: 23rem;
  }
`;

export const ErrorContainer = styled.div`
  padding: 120px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50rem;
  height: 50rem;
  margin: auto;
`;

export const Description = styled.p`
  font-size: 18px;
  line-height: 28px;
  max-width: 435px;
  margin: 0 auto;
  margin-top: 50px;
  text-align: center;
  span {
    font-weight: 900;
  }
`;
